import React from 'react'
import { Switch, Route, RouteComponentProps } from 'react-router-dom'

import ApplyPromotionModal from '../../../../containers/riders/riderdetails/ApplyPromotionModal'
import AppliedPromotions from '../../../../containers/riders/riderdetails/AppliedPromotions'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IPromotionsPaneProps {
  riderId: string
}

export default class PromotionsPane extends React.Component<IPromotionsPaneProps & RouteComponentProps> {
  public render() {
    const applyPromotion = (props: RouteComponentProps) => (
      <ApplyPromotionModal {...props} userId={this.props.riderId} />
    )

    const appliedPromotions = (props: RouteComponentProps) => (
      <AppliedPromotions {...props} userId={this.props.riderId} />
    )

    return (
      <FloatingForm fullHeight={true}>
        <Switch>
          <Route path={`${this.props.match.path}`} render={appliedPromotions} />
        </Switch>
        <Route path={`${this.props.match.path}/apply`} render={applyPromotion} />
      </FloatingForm>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/promotions/AppliedPromotionsPane.tsx